import { Component, Input, OnInit } from '@angular/core';
import { Issue } from '../../models/issue';
import { SettingsService } from '../../services/settings.service';

@Component({
  selector: 'app-last-updated',
  templateUrl: './last-updated.component.html',
  styleUrls: ['./last-updated.component.scss']
  })
export class LastUpdatedComponent implements OnInit {
  @Input() public issue: Issue;
  @Input() public isCardView = false;

  constructor(private settingsService: SettingsService) { }

  ngOnInit() {
  }

  isOverdue(): boolean {
    if (!this.issue || !this.issue.updatedAt) {
      return false;
    }
    const updatedDate = new Date(this.issue.updatedAt);
    const now = new Date();

    const timeoutMinutes = this.settingsService.getMarkAsUnseenTimeout();

    // If timeout is 0, feature is disabled
    if (timeoutMinutes <= 0) {
      return false;
    }

    const timeoutMs = timeoutMinutes * 60 * 1000;
    return (now.getTime() - updatedDate.getTime()) > timeoutMs;
  }
}
